const { map } = require("jquery")

module.exports = {

  init() {

    this.changeView()

    this.sortByPrice()

    if (document.getElementById('search_map')) this.mapView()
    
    if (document.getElementById('property_map')) this.propertyMap()

  },
  /**
   * Toggle search form value & submit
   * @return null
   */
  changeView() {
    $('[data-view]').click((e)=>{
      $('[name="ResultsView"]').val($(e.target).attr('data-view'))
      $('form.search').submit()
    })
  },
  /**
   * Sort by price ASC/DESC
   * @return null
   */
  sortByPrice() {
    $('.SortByPrice').change((e)=>{
      let values = $('.SortByPrice').val().split('_');
      $('[name="OrderByColumn"]').val(values[0])
      $('[name="OrderBy"]').val(values[1])
      $('form.search').submit()
    })
  },
  /**
   * generate map
   * @return null
   */
  mapView() {

    if (!window.mapData) return

    let loader = new mapLoader(designamite.mapApiKey, {})

    let map = document.getElementById('search_map'),
        data = window.mapData,
        self = this;

    loader.load().then(function (google) {

      let bounds = new google.maps.LatLngBounds()

      let mapObject = new google.maps.Map(map, {
        zoom: 10,
        styles: designamite.searchMapStyles,
      })

      let zoomChangeBoundsListener = google.maps.event.addListener(
        mapObject, 'bounds_changed',
        function(event) {
          google.maps.event.removeListener(zoomChangeBoundsListener);
          mapObject.setZoom( Math.min( 15, mapObject.getZoom() ) );
        });

      let markers = []  
      let longlat = []
      
      for (var i=0; i<data.length; i++) {

        let item = data[i]

        if(longlat[`${item.latitude} ${item.longitude}`]) 
        {
          longlat[`${item.latitude} ${item.longitude}`]++
        }    
        else 
        {
          longlat[`${item.latitude} ${item.longitude}`] = 1
        }

        if(longlat[`${item.latitude} ${item.longitude}`] > 1)
        {
          item.latitude = parseFloat(item.latitude) + Math.random() / 50000
          item.longitude = parseFloat(item.longitude) + Math.random() / 50000
        }
          
        latlng = new google.maps.LatLng(
              parseFloat(item.latitude), 
              parseFloat(item.longitude)
            );

        let marker = new google.maps.Marker({
          map: mapObject,
          position: latlng,
          _property_id: item.id,
        })

        bounds.extend(latlng)

        google.maps.event.addListener(marker, 'click', function() {
          self.previewProperty(this._property_id)
        })

        markers.push(marker)

      }

      const markerCluster = new MarkerClusterer({markers});

      markerCluster.setMap(mapObject);

      mapObject.fitBounds(bounds)

    });

  },

  /**
   * load property map preview
   * @param string id property id
   * @return null 
   */
  previewProperty(id) {

    let el = $('.property-map-preview')

    var data =  {
      action: 'property_preview_map',
      property_id: id,
    }
 
    $.post(ajax_object.ajax_url, data, function(response){

      el.html(response)

      if ('' != response) {
        el.addClass('property-map-preview--open')
      } else {
        el.removeClass('property-map-preview--open')
      }

      $('.map-preview-close').click((e)=>{
        el.removeClass('property-map-preview--open')
        el.html('')
      })

    })


  },
  
  /**
   * generate map
   * @return null
   */
  propertyMap() {

    if ($('#property_map').length == 0) return

    let loader = new mapLoader(designamite.mapApiKey, {})

    let map = document.getElementById('property_map'),
        lat = parseFloat($('#property_map').attr('data-lat')),
        lng = parseFloat($('#property_map').attr('data-lng')),
        latlng = {lat: lat, lng: lng};
    
    loader.load().then(function (google) {

      let mapObject = new google.maps.Map(map, {
        zoom: 10,
        center: latlng,
        styles: designamite.searchMapStyles,
      })
      
      new google.maps.Marker({
        position: latlng,
        map: mapObject,
      })

    });

  },


}
